import React, { useContext, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import { FaSearch, FaAngleDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import renderHTML from "react-render-html";
import Config from "../config.json";
import ContextComponent from "../Context";
import Loading from "./Loading";
import { FaRss } from "react-icons/fa";
import Statics from "../Statics";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | بلاگ",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const PostIndex = () => {
  const [posts, setPosts] = useState([]);
  const [searchedPosts, setSearchedPosts] = useState(null);
  const [postsRelativeCategory, setPostsRelativeCategory] = useState(null);
  const [postSize, setPostSize] = useState(8);
  const [searchedTerm, setSearchedTerm] = useState("");
  const [loadFlag, setLoadFlag] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("allCategory");
  const [categories, setCategories] = useState(null);
  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);

  const { ApiDriver } = useContext(ContextComponent);

  // Helper functions
  const highlightText = (html, searchTerm) => {
    if (!searchTerm) return { __html: html };
    const regex = new RegExp(`(${searchTerm})`, "gi");
    const highlightedHtml = html.replace(
      regex,
      '<mark class="search-mark">$1</mark>',
    );
    return { __html: highlightedHtml };
  };

  const stripHtml = html => {
    if (!html) return "";
    let plainText = html.replace(/&nbsp;/g, " ").replace(/&zwnj;/g, "‌");
    plainText = plainText.replace(/<[^>]+>/g, "");
    return plainText;
  };

  const getSnippet = (text, searchTerm, wordsBefore = 9, wordsAfter = 9) => {
    if (!text || !searchTerm) return "";
    const plainText = stripHtml(text);
    const words = plainText.split(/\s+/);
    const searchWords = searchTerm.trim().split(/\s+/);
    let matchIndex = -1;

    for (let i = 0; i < words.length; i++) {
      if (words[i].toLowerCase().includes(searchWords[0].toLowerCase())) {
        matchIndex = i;
        break;
      }
    }

    if (matchIndex === -1) return "";
    const start = Math.max(0, matchIndex - wordsBefore);
    const end = Math.min(words.length, matchIndex + wordsAfter + 1);
    const snippet = words.slice(start, end).join(" ");
    return (
      (start > 0 ? "... " : "") + snippet + (end < words.length ? " ..." : "")
    );
  };

  // Data fetching

  const loadInitialPosts = () => {
    setLoadingState(Statics.LOADING);
    ApiDriver.getPosts(
      { page_size: 24 },
      data => {
        setPosts(data);
        sessionStorage.setItem("posts", JSON.stringify(data));
        setLoadingState(Statics.LOADED);
        loadMorePosts(64);
      },
      error => {
        console.error(error);
        setLoadingState(Statics.CAUSED_ERROR);
      },
    );
  };

  const loadCategories = () => {
    ApiDriver.getCategories(
      { page_size: 1000 },
      data => {
        setCategories(data);
        sessionStorage.setItem("allCategories", JSON.stringify(data));
      },
      error => {
        console.log(error);
      },
    );
  };

  const loadMorePosts = size => {
    ApiDriver.getPosts(
      { page_size: size },
      data => {
        setPosts(data);
        sessionStorage.setItem("posts", JSON.stringify(data));
        if (size === 64) loadMorePosts(128);

        if (size === 128) loadMorePosts(1000);
      },
      error => console.error(error),
    );
  };

  // Handlers

  const handleCategoryId = id => {
    setSelectedCategory(id);
    setPostsRelativeCategory(
      posts.filter(post =>
        post.categories.some(category => category.id === id),
      ),
    );
  };

  const handleSearch = searchedTerm => {
    const results = posts.filter(
      post =>
        post.title.includes(searchedTerm) || post.body.includes(searchedTerm),
    );
    setSearchedPosts(results);
    setSelectedCategory(null);
  };

  const showMoreHandler = () => {
    if (
      posts &&
      ((posts.length === 24 && postSize === 24) ||
        (posts.length === 64 && postSize === 64))
    ) {
      setLoadFlag(true);
    }
    setPostSize(prevSize => prevSize + 8);
  };

  // Effects

  useEffect(() => {
    const cachedPosts = sessionStorage.getItem("posts");
    const storedCategories = sessionStorage.getItem("allCategories");
    if (cachedPosts) {
      setPosts(JSON.parse(cachedPosts));
      setLoadingState(Statics.LOADED);
    } else {
      loadInitialPosts();
    }
    if (storedCategories) {
      setCategories(JSON.parse(storedCategories));
    } else {
      loadCategories();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedCategory && selectedCategory !== "allCategory")
      handleCategoryId(selectedCategory);
    if (posts && (posts.length === 64 || posts.length === 128)) {
      setLoadFlag(false);
    }
    if (searchedPosts) handleSearch(searchedTerm);
    // eslint-disable-next-line
  }, [posts]);

  return (
    <DocumentMeta {...page_meta}>
      <div className="blog-header">
        <h1>بلاگ پژوهیار</h1>
        <div className="blog-search-box">
          <input
            type="text"
            value={searchedTerm}
            onKeyPress={e => e.key === "Enter" && handleSearch(searchedTerm)}
            onChange={e => {
              setSearchedTerm(e.target.value);
              if (e.target.value === "") {
                setSelectedCategory("allCategory");
                setSearchedPosts(null);
              }
            }}
            placeholder="جستجو کنید ..."
          />
          <FaSearch
            className="blog-search-icon"
            onClick={() => handleSearch(searchedTerm)}
          />
        </div>
        <a
          href={`https://core.pajoohyar.ir/web/feed/blog.rss${
            selectedCategory !== "allCategory"
              ? `?category-id=${selectedCategory}`
              : ""
          }`}
          target="_blank"
          rel="noopener noreferrer"
          className="blog-rss">
          Rss
          <FaRss size={30} className=" blog-rss-icon pr-2" />
        </a>
      </div>

      <div className="blog-categories">
        {loadingState === Statics.LOADED ? (
          <button
            className={`${
              selectedCategory === "allCategory" ? "blog-category-active" : ""
            }`}
            onClick={() => {
              setPostsRelativeCategory(null);
              setSearchedPosts(null);
              setSearchedTerm("");
              setSelectedCategory("allCategory");
            }}>
            همه مطالب
          </button>
        ) : null}

        {categories && !searchedPosts
          ? categories.map(category => (
              <button
                className={`${
                  category.id === selectedCategory ? "blog-category-active" : ""
                }`}
                key={category.id}
                onClick={() => handleCategoryId(category.id)}>
                {category.title}
              </button>
            ))
          : null}
      </div>
      {loadingState === Statics.LOADING ? (
        <div className="pajoohyar-loading">
          <Loading />
        </div>
      ) : (
        <>
          {loadingState === Statics.CAUSED_ERROR ? (
            <div className="error-parent">
              <p>ارتباط با سرور با مشکل مواجه شد !</p>
              <img
                className="error-img"
                src="images/errorPic.webp"
                width="200px"
                alt="error-png"
              />
            </div>
          ) : null}
          {loadingState === Statics.LOADED ? (
            <>
              <div className="blog-list">
                {searchedPosts
                  ? searchedPosts.map(post => (
                      <Link
                        target="_blunk"
                        className="blog-card-container"
                        to={"/blog/post/" + post.id}>
                        <div className="blog-card">
                          <img src={post.cover_pic_urls.lg} alt="Blog" />
                          <div className="content">
                            <span
                              dangerouslySetInnerHTML={highlightText(
                                post.title,
                                searchedTerm,
                              )}
                            />
                            <p className="outbox-content">
                              {searchedTerm && (
                                <div
                                  className="search-snippet"
                                  style={{ fontSize: "15px" }}>
                                  <span
                                    dangerouslySetInnerHTML={highlightText(
                                      getSnippet(
                                        stripHtml(post.body),
                                        searchedTerm,
                                      ),
                                      searchedTerm,
                                    )}
                                  />
                                </div>
                              )}
                            </p>
                            <div class="read-more-item-card">
                              <span> برای دیدن ادامه مطلب کلیک کنید</span>
                              <Row
                                style={{
                                  fontSize: "12px",
                                  color: "#a8a8b3",
                                  padding: "10px",
                                }}>
                                <span>نویسنده: {post.author_name}</span>
                                {"\u00A0"}
                                <span>
                                  (تاریخ انتشار:{" "}
                                  {`${post.published_at.year}/${post.published_at.month}/${post.published_at.day}`}
                                  )
                                </span>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))
                  : null}

                {postsRelativeCategory && !searchedPosts
                  ? postsRelativeCategory.map(post => (
                      <Link
                        target="_blunk"
                        className="blog-card-container"
                        to={"/blog/post/" + post.id}>
                        <div className="blog-card">
                          <img src={post.cover_pic_urls.lg} alt="Blog" />
                          <div className="content">
                            <h3>{post.title}</h3>
                            <p className="outbox-content">
                              {renderHTML(post.summary)}
                            </p>
                            <div class="read-more-item-card">
                              <span> برای دیدن ادامه مطلب کلیک کنید</span>
                              <Row
                                style={{
                                  fontSize: "12px",
                                  color: "#a8a8b3",
                                  padding: "10px",
                                }}>
                                <span>نویسنده: {post.author_name}</span>
                                {"\u00A0"}
                                <span>
                                  (تاریخ انتشار:{" "}
                                  {`${post.published_at.year}/${post.published_at.month}/${post.published_at.day}`}
                                  )
                                </span>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))
                  : null}

                {posts && !searchedPosts && selectedCategory === "allCategory"
                  ? posts.slice(0, postSize).map(post => (
                      <Link
                        key={post.id}
                        target="_blunk"
                        className="blog-card-container"
                        to={"/blog/post/" + post.id}>
                        <div className="blog-card">
                          <img src={post.cover_pic_urls.lg} alt="Blog" />
                          <div className="content">
                            <h3>{post.title}</h3>
                            <div className="outbox-content">
                              {renderHTML(post.summary)}
                            </div>
                            <div className="read-more-item-card">
                              <span> برای دیدن ادامه مطلب کلیک کنید</span>
                              <Row
                                style={{
                                  fontSize: "12px",
                                  color: "#a8a8b3",
                                  padding: "10px",
                                }}>
                                <span>نویسنده: {post.author_name}</span>
                                {"\u00A0"}
                                <span>
                                  (تاریخ انتشار:{" "}
                                  {`${post.published_at.year}/${post.published_at.month}/${post.published_at.day}`}
                                  )
                                </span>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))
                  : null}
              </div>
              <div className="blog-show-more-btn-parent">
                {postsRelativeCategory || searchedPosts ? null : (
                  <button
                    className="blog-show-more-btn"
                    onClick={() => showMoreHandler()}>
                    نمایش بیشتر <FaAngleDown />
                  </button>
                )}

                {loadFlag && selectedCategory === "allCategory" ? (
                  <div className="pajoohyar-loading-small">
                    <Loading />
                  </div>
                ) : null}
                {(selectedCategory || searchedPosts) &&
                posts.length <= 150 &&
                selectedCategory !== "allCategory" ? (
                  <div>
                    <Loading />
                  </div>
                ) : null}
              </div>
            </>
          ) : null}
        </>
      )}
    </DocumentMeta>
  );
};

export default PostIndex;
